import React from 'react';
import FromDateToDateFilter from './Components/FromDateToDateFilter';
import {RequestBillingListType} from '../../types/CashierSliceStateType';
import {dateFormatter} from '../../assets/utils/dateUtils';
import FilterWrapper from './FilterWrapper';

type Props = {
	active: boolean;
	setFilters: any;
};

const CashOrdersFilter: React.FC<Props> = ({active, setFilters}) => {
	const date = new Date();
	const initialValues: RequestBillingListType = {
		from_date: '',
		to_date: '',
	};

	const handleSubmit = (values: RequestBillingListType) => {
		setFilters(values);
	};

	const handleReset = () => {
		setFilters({
			from_date: dateFormatter(date),
			to_date: dateFormatter(date),
		});
	};

	return (
		<FilterWrapper
			active={active}
			initialValues={initialValues}
			onSubmit={handleSubmit}
			onReset={handleReset}
		>
			{() => (
				<FromDateToDateFilter
					toDateFieldName="to_date"
					byDateFieldName="from_date"
				/>
			)}
		</FilterWrapper>
	);
};

export default CashOrdersFilter;
